<template>

		<v-snackbar
			:timeout="-1"
			v-model="showSnackbar"
			bottom
			right
			:dark="false"
			light
			elevation="3"
			:content-class="contentClass"
		>
			<template v-if="snackbar.type == 'notification' && snackbar.data">
				<avatar v-if="snackbar.data.what.user" :user="snackbar.data.what.user" sm class="mr-2"/>
				<v-avatar
					v-else
					color="primary"
					size="32"
					class="mr-2"
				>
					<v-icon color="white">$notification</v-icon>
				</v-avatar>
				<div>
					{{ snackbar.data.message }}
					<div class="mt-3">
						<router-link :to="$notificationUrl(snackbar.data)" @click.native="handleNotification()" class="link">{{ $vuetify.lang.t('$vuetify.notifications.goToUrl') }}</router-link>
					</div>
				</div>
			</template>
			<template v-else-if="snackbar.type == 'error'" v-html="message">
				<div style="display: flex; flex-direction: column">
					<div style="display: flex; flex-direction: row; align-items: center">
						<v-icon left class="mr-2">mdi-information-outline</v-icon> 
						<div>
							<span v-if="error.code" class="bold">({{ error.code }})</span> {{ message }}
							<div v-if="error.errors" style="margin-left: 20px">
								<ul>
									<li v-for="(e, index) in error.errors" :key="index">
										<span class="bold ">{{ e.field }}: </span>
										<template v-if="e.descriptions.length == 1">
											{{ e.descriptions[0] }}
										</template>
										<template v-else>
											<ul>
												<li v-for="(description, idx) in e.descriptions" :key="idx">{{ description }}</li>
											</ul>
										</template>
									</li>
								</ul>
							</div>
						</div>
					</div>
				</div>
			</template>
			<template v-else-if="snackbar.type == 'success'">
				<v-icon left>mdi-check</v-icon> {{ message }}
			</template>
			<v-btn icon class="close-btn" plain @click="close()"><v-icon small>mdi-close</v-icon></v-btn>
	</v-snackbar>

	
</template>

<script>
import Avatar from '@/components/Avatar'
export default {
	components: {
		Avatar
	},
	props: {
		snackbar: {
			type: Object
		}
	},
	data() {
		return {
			showSnackbar: true,
			timer: 5000,
		}
	},
	computed: {
		error() {
			let error = {};
			if(this.snackbar.data && this.snackbar.data.error) {
				if(this.snackbar.data.error.response) {
					if(this.snackbar.data.error.response.status) {
						error.code = this.snackbar.data.error.response.status;

						if(this.snackbar.data.error.response.data && this.snackbar.data.error.response.data.errors) {
							error.errors = [];
							Object.keys(this.snackbar.data.error.response.data.errors).forEach(key => {
								let e = this.snackbar.data.error.response.data.errors[key];
								let obj = {
									field: key,
									descriptions: []
								}
								e.forEach(x => {
									obj.descriptions.push(x)
								})
								error.errors.push(obj)
							})
							// error.data = this.snackbar.data.error.response.data;
						}
					}
				}
			}

			if(error && error.code) {
				if(error.code == 404) {
					error.text = this.snackbar.data.message || 'Żądany obiekt nie istnieje';
				}
				else if(error.code == 401) {
					error.text = this.snackbar.data.message || 'Musisz się zalogować';
				}
				else if(error.code == 403) {
					error.text = this.snackbar.data.message || 'Nie masz uprawnień do wykonania tej operacji'
				}
				else if(error.code == 422) {
					error.text = this.snackbar.data.message || 'Przesłane dane nie są poprawne'
				}
				else if(error.code == 423) {
					error.text = this.snackbar.data.message || 'Żądany obiekt jest zablokowany'
				}
				else if(error.code >= 500) {
					error.text = this.snackbar.data.message || 'Wystąpił błąd serwera, proszę spróbować później'
				}
			}
			return error;
		},
		message() {
			if(typeof this.snackbar.data === 'string' && this.snackbar.data !== '') {
				return this.snackbar.data;
			}
			else if(this.snackbar.data && this.snackbar.data.text) {
				return this.snackbar.data.text;
			}
			else if(this.error) {
				return this.error.text
			}
			return 'Brak treści';
		},
		contentClass() {
			let c = 'd-flex flex-row snack w-100';
			if(this.snackbar.type == 'error') {
				c += ' align-items-center snack-error';
			}
			else if(this.snackbar.type == 'success') {
				c += ' align-items-center snack-success';
			}
			else if(this.snackbar.type == 'notification') {
				c += ' snack-notification';
			}
			return c;
		}
	},
	methods:{
		async handleNotification() {
			await this.$store.dispatch('notifications/updateStatus', {
				action: 'clicked',
				notification_ids: [this.snackbar.data.id]
			});
			this.close();
		},
		show(data) {
			this.type = data.type;
			if(data.error) {
				this.data.error = data.error;
			}
			this.data.text = data.message || 'missing "message".'
			// this.color = data.color || 'success'
			if(data.timer) {
				this.timer = data.timer;
			}
			if(data.icon) {
				this.data.icon = data.icon
			}
			this.showSnackbar = true
			
		},
		close() {
			this.$store.commit('application/hideSnackbar')
		},
		setTimer() {
			if(this.timer) {
				window.snackbarTimeout = setTimeout(() => {
					this.close();
				}, this.timer);
			}
		},
		clearTimer() {
			clearTimeout(window.snackbarTimeout)
		}
	},
	created() {
		if(this.snackbar) {
			console.log("ERROR", this.error)
			if(this.snackbar.timer) {
				this.timer = this.snackbar.timer;
			}
			else {
				if(this.snackbar.type == 'error') {
					this.timer = null;
				}
			}
		}
		this.setTimer();
		
	},
	beforeDestroy() {
		console.log("CLEAR TIMEOUT")
		
	}
}
</script>

<style lang="scss">
	.snack {
		.bold {
			font-weight: bold;
		}
		.mr-2 {
			margin-right: 10px;
		}
		.mr-1 {
			margin-right: 5px;
		}
		width: 100%;
		color: $app-color;
		font-family: $body-font-family;
		border-radius: $border-radius-root;
		border-color: inherit;
		border: none;
		&.d-flex {
			display: flex;
		}
		&.flex-row {
			flex-direction: row;
		}
		&.align-items-center {
			align-items: center;
		}
		.close-btn {
			margin-left: auto;
		}

		&.snack-error {
			background: var(--v-red-base);
			color: white;
			.v-icon {
				color: white !important;
			}
		}

		&.snack-success {
			background: var(--v-success-base);
			color: white;
			.v-btn, .v-icon {
				color: white !important;
			}
		}
	}
</style>